module.exports = __webpack_public_path__ + "img/go-to-app.76979835.png";